import * as React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button } from "../../../../components/ui/button";
import { Trash2, Plus, Pencil } from "lucide-react";
import { StateMileageDialog } from "./StateMileageDialog";
import { stateOptions } from "data";
import { FieldError } from "../FieldError";

export function StateMileage() {
  const { control, watch } = useFormContext();
  const { fields, append, remove, update } = useFieldArray({ 
    control, 
    name: "step8.stateMileage" 
  });
  const annualMileage = watch("step8.annualMileage");

  const [open, setOpen] = React.useState(false);
  const [editingIndex, setEditingIndex] = React.useState(null);

  const handleEdit = (idx) => {
    setEditingIndex(idx);
    setOpen(true);
  };

  const handleSave = (item) => {
    if (editingIndex !== null) {
      update(editingIndex, item); // replaces the commodity at index
      setEditingIndex(null);
    } else {
      append(item);
    }
  };

  return (
    <section className="rounded-xl space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold">State Mileage (miles must equal your Annual Mileage inputted above)</h3>
        <Button 
          className="bg-red-600 hover:bg-red-700 text-white" 
          onClick={() => {
            setEditingIndex(null);
            setOpen(true);
          }}
        >
          <Plus className="h-4 w-4 mr-2" /> Add State
        </Button>
      </div>

      {fields.length === 0 ? (
        <p className="text-sm text-gray-600">
          No state mileages added. Please click add state to get started.
        </p>
      ) : (
        <div className="space-y-2">
          {fields.map((c, idx) => (
            <div 
              key={c.id} 
              className="flex items-center justify-between rounded-md border p-3"
            >
              <div className="text-sm">
                <div className="font-medium">
                  {stateOptions.find((co) => co.value === c.state)?.label }
                </div>
                <div className="text-gray-500">{c.percentage}% of loads</div>
                {c.miles != null && c.miles !== "" && (
                  <div className="text-gray-500">{c.miles} miles</div>
                )}
                <div className="space-y-1 pt-1">
                  <FieldError name={`step8.stateMileage.${idx}.percentage`} />
                  <FieldError name={`step8.stateMileage.${idx}.miles`} />
                </div>
              </div>
              <div className="flex gap-1">
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => handleEdit(idx)} 
                  aria-label="Edit mileage"
                >
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => remove(idx)} 
                  aria-label="Remove mileage"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
          <FieldError name={"step8.stateMileage"} step={"step8"} />
        </div>
      )}

      <StateMileageDialog
        open={open}
        onOpenChange={(o) => {
          setOpen(o);
          if (!o) setEditingIndex(null);
        }}
        onAdd={handleSave}
        annualMileage={annualMileage}
        defaultValues={editingIndex !== null ? fields[editingIndex] : undefined}
      />
    </section>
  );
}
